function n(n, t) {
  for (var r in t) {
    n[r] = t[r];
  }

  return n;
}

export default function (t) {
  var r = [];

  function u(n) {
    for (var t = [], u = 0; u < r.length; u++) {
      r[u] === n ? n = null : t.push(r[u]);
    }

    r = t;
  }

  function e(u, e, f) {
    t = e ? u : n(n({}, t), u);

    for (var i = r, o = 0; o < i.length; o++) {
      i[o](t, f);
    }
  }

  return t = t || {}, {
    action: function action(n) {
      function r(t) {
        e(t, !1, n);
      }

      return function () {
        for (var u = arguments, e = [t], f = 0; f < arguments.length; f++) {
          e.push(u[f]);
        }

        var i = n.apply(this, e);
        if (null != i) return i.then ? i.then(r) : r(i);
      };
    },
    setState: e,
    subscribe: function subscribe(n) {
      return r.push(n), function () {
        u(n);
      };
    },
    unsubscribe: u,
    getState: function getState() {
      return t;
    }
  };
}